import React from 'react'
import { useContext } from 'react';
import { GlobalState } from '../../GlobalState';
import { api } from '../../util/urlConfig';
import moment from 'moment';
import { useEffect } from 'react';
import './supplierFeedbackNotifyComponent.css'
import { useState } from 'react';
import axios from '../../helpers/axios';

export default function ProductNotifyComponent({ productId }) {
    const [productDetail, setProductDetail] = useState(null);

    const getProductDetail = async (id) => {
        const data = await axios.get(`/product/${id}`);
        setProductDetail(data.data.response.data);
    }


    useEffect(() => {
        getProductDetail(productId);
    }, [productId,])

    return (
        <>
            {
                productDetail ?
                    <div className='notify-main-container'>
                        <div className='notify-content-area'>
                            <img className='notify-img' src={productDetail.upload_image ? api + "/" + productDetail.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
                            <div className='notify-content-detail'>
                                <div className='notify-name'>
                                    {
                                        productDetail ? productDetail.name : 'Product'
                                    }
                                </div>


                                <div className='notify-subname'>{productDetail.name} has arrived.</div>
                                <div className='notify-subname'>
                                    <i className='uil uil-clock'></i>
                                    <span>{moment(productDetail.created_at).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}
